import styled from "styled-components"
import { MainContentStyles } from "./main-content-styles"

export const MainContent = styled.main`
  min-height: 230px;
  ${MainContentStyles}
`
